import { useContext, useEffect, useState } from 'react';
import { ViContext } from '../../context/ViContext';

import axios from 'axios';
import OriginContent from './OriginContent';
import WeightedContent from './WeightedContent';

function SelectWrap() {
	const {
		setSelectSgg,
		setSelectEmd,
		mapMode,
		setMapMode,
		setSidoCode,
		setSggCode,
		setEmdCode,
		setPop,
		setProd,
		setConsume,
		execFunctionLog
	} = useContext(ViContext);

	const [selectWrapOpen, setSelectWrapOpen] = useState(true);

	const handelSelectRadio = (e) => {
		if (e.target.name === 'selectSgg') {
			execFunctionLog('시군구 단위 지역활력지수 조회', '시군구 단위 영역별 활력도 결과 조회 기능 제공');
			setSelectSgg(e.target.value);
		}
		if (e.target.name === 'selectEmd') {
			execFunctionLog('읍면동 단위 지역활력지수 조회', '읍면동 단위 영역별 활력도 결과 조회 기능 제공');
			setSelectEmd(e.target.value);
		}
	};

	const handelMapMode = (event) => {
		const targetName = event.target.name;
		setSidoCode('');
		setSggCode('');
		setEmdCode('');
		setPop(1);
		setProd(1);
		setConsume(1);
		setSelectSgg('region');
		setSelectEmd('region');

		setMapMode(targetName);
	};

	return (
		<div
			className={
				selectWrapOpen
					? `mapSelectWrap subSelectWrap`
					: `mapSelectWrap subSelectWrap hide ${mapMode}Hide`
			}
		>
			<div
				className="hideBtn"
				onClick={() => setSelectWrapOpen(!selectWrapOpen)}
			>
				<img src="./img/leftMenuHideBtn.png" alt="닫기" />
			</div>

			{mapMode === 'origin' ? (
				<OriginContent handelSelectRadio={handelSelectRadio} />
			) : (
				<WeightedContent />
			)}
			<div className="dotLine" />
			<button
				className="mapModeBtn"
				name={mapMode === 'origin' ? 'weighted' : 'origin'}
				onClick={(e) => handelMapMode(e)}
			>
				{mapMode === 'origin' ? '영역별 가중치 조절하기' : '이전 화면'}
			</button>
		</div>
	);
}

export default SelectWrap;
